import { gql } from '@apollo/client';

export const UPDATE_GENERIC_ENTITY_FLOW = gql`
  mutation updateGenericEntityFlow($input: GenericEntityFlowInput) {
    updateGenericEntityFlow(input: $input) {
      commandId
    }
  }
`;

export const UPDATE_GENERIC_ENTITY_FLOW_STATES = gql`
  mutation updateGenericEntityFlowStates($flowId: ID!, $input: [GenericEntityFlowStateInput]) {
    updateGenericEntityFlowStates(flowId: $flowId, input: $input) {
      commandId
    }
  }
`;

export const DELETE_GENERIC_ENTITY_FLOW = gql`
  mutation deleteGenericEntityFlow($flowId: ID!) {
    deleteGenericEntityFlow(flowId: $flowId) {
      commandId
    }
  }
`;
